import React, { useState, useContext, useEffect } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import './footer.scss';
import logo from '../../../assets/logo_red.png';
import { translateText } from '../../../services/deeplTranslationService';
import { LanguageContext } from '../../../services/LanguageContext';
import { useParams } from 'react-router-dom';

const Footer = () => {
    const { lang } = useParams(); // Get the 'lang' parameter from the URL
    const { language } = useContext(LanguageContext); // Get language from context
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');

    const [translatedTexts, setTranslatedTexts] = useState({
        agb: 'AGB',
        impressum: 'Impressum',
        datenschutz: 'Datenschutz',
        kontakt: 'Kontakt',
        ueberUns: 'Über uns',
        faq: 'FAQ',
        login: 'Login',
        newsletter: 'Newsletter abonnieren',
        subscribeButton: 'Los',
    });

    useEffect(() => {
        const translateFooterTexts = async () => {
            const translations = await Promise.all([
                translateText('AGB', language),
                translateText('Impressum', language),
                translateText('Datenschutz', language),
                translateText('Kontakt', language),
                translateText('Über uns', language),
                translateText('FAQ', language),
                translateText('Login', language),
                translateText('Newsletter bestellen', language),
                translateText('Los', language),
            ]);

            setTranslatedTexts({
                agb: translations[0],
                impressum: translations[1],
                datenschutz: translations[2],
                kontakt: translations[3],
                ueberUns: translations[4],
                faq: translations[5],
                login: translations[6],
                newsletter: translations[7],
                subscribeButton: translations[8],
            });
        };

        translateFooterTexts();
    }, [language]);

    // Newsletter subscription handler
    const handleSubscribe = async () => {
        if (!email) {
            setModalMessage('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
            setShowModal(true);
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(
                `https://find-together-api.sslbeta.de/api/Newsletter/subscribe?email=${encodeURIComponent(email)}`,
                { method: 'POST', headers: { 'Content-Type': 'application/json' } }
            );
            const data = await response.json();
            if (response.ok) {
                setModalMessage('Abonnement erfolgreich!');
            } else {
                setModalMessage(data.message || 'Abonnement fehlgeschlagen.');
            }
        } catch (error) {
            setModalMessage('Ein Fehler ist aufgetreten.');
        } finally {
            setLoading(false);
            setShowModal(true);
        }
    };

    // Modal close handler
    const handleClose = () => {
        setShowModal(false);
    };

    return (
        <div className='footer-section'>
            <div className='container home-container mb-5 secondary-background-color'>
                <Row className='pt-5'>
                    <Col sm={12} md={3} className='hilfe'>
                        <a href={`/${lang}/legal/agb`}>{translatedTexts.agb}</a>
                        <a href={`/${lang}/legal/impressum`}>{translatedTexts.impressum}</a>
                        <a href={`/${lang}/legal/datenschutz`}>{translatedTexts.datenschutz}</a>
                    </Col>
                    <Col sm={12} md={3} className='bereiche'>
                    <a href="mailto:support@findtogether.de?subject=Kontakt">{translatedTexts.kontakt}</a>
                    <a href={`/${lang}/about`}>{translatedTexts.ueberUns}</a>
                        <a href={`/${lang}/faq`}>{translatedTexts.faq}</a>
                        <a href={`/${lang}/Anmeldung`}>{translatedTexts.login}</a>
                    </Col>
                    <Col sm={12} md={3} className='uns'>
                        <a href="https://www.facebook.com/profile.php?id=61564938482464" target="_blank" rel="noopener noreferrer">Facebook</a>
                        <a href="https://www.instagram.com/findtogether_app/" target="_blank" rel="noopener noreferrer">Instagram</a>
                        <a href="https://www.tiktok.com/@find_together" target="_blank" rel="noopener noreferrer">Tiktok</a>
                    </Col>
                    <Col sm={12} md={3} className="newsletter-container">
                        <img src={logo} alt="Find Together Logo" className='footer-logo' />
                        <p className='fw-bold'>{translatedTexts.newsletter}</p>
                        <div className="newsletter-input-container">
                            <input
                                type="email"
                                placeholder="E-Mail-Adresse"
                                className="newsletter-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <button type="button" onClick={handleSubscribe} className="newsletter-button">
                                {loading ? <span className="bubble-spinner"></span> : translatedTexts.subscribeButton}
                            </button>
                        </div>
                    </Col>
                </Row>

                <Modal show={showModal} onHide={handleClose} centered>
                    <Modal.Body
                        className='d-flex justify-content-between'
                        style={{ backgroundColor: modalMessage === 'Fehler' ? '#ffcccc' : '#e7f6ec' }}
                    >
                        {modalMessage}
                        <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
};

export default Footer;
